export enum InsuranceType {
  SIMAS = 104,
  INTRA_ASIA = 103
}

export const createInsuranceTypeList = function () {
  return [
    {
      name: 'Simas',
      value: InsuranceType.SIMAS
    },
    {
      name: 'Intra Asia',
      value: InsuranceType.INTRA_ASIA
    }
  ]
}
